/**
 * デバイス名を渡して、true か false を返す
 * @returns true か false を返す
 */
export function IsDevice(deviceName: string): boolean {
    let isTrue = false;
    switch (deviceName) {
        case "iphone":
            if (isIphone()) isTrue = true;
            break;
        case "ipad":
            if (isIpad()) isTrue = true;
            break;
        case "desktop":
            if (isDesktop()) isTrue = true;
            break;
        default:
            break;
    }
    return isTrue;
}

/**
 * desktopかどうかのフラグを取得する
 * @returns true か false を返す
 */
export function isDesktop(): boolean {
    if (navigator.userAgent.match(/(iPhone|iPad|iPod|Android.*Mobile)/i) || isIpad()){
        // スマホ（iPhone・Androidスマホ）、iPadの場合
        return false;
    } else {
        return true;
    }
}

/**
 * iPadかどうかのフラグを取得する
 * @returns true か false を返す 
 */
export function isIpad(): boolean {
    const ua = window.navigator.userAgent.toLowerCase();
    if ((ua.indexOf("ipad") > -1 || ua.indexOf("macintosh") > -1) && "ontouchend" in document) {
        return true;
    } else {
        return false;
    }
}

/**
 * iPhoneかどうかのフラグを取得する
 * @returns true か false を返す 
 */
export function isIphone(): boolean {
    if(!isDesktop() && !isIpad()) return true;
    return false;
}
